const tintColorLight = "#0a7ea4";
const tintColorDark = "#fff";

export const labelColor = [
  "#b60205",
  "#d9420b",
  "#fbca04",
  "#0e8a16",
  "#006b75",
  "#1d76db",
  "#0052cc",
  "#5319e7",
  "#e99695",
  "#f9d0c1",
  "#fef2c0",
  "#c2e0c6",
  "#bfdadc",
  "#c5def5",
  "#bfd4f2",
  "#d4c5f9",
];

export const Colors = {
  light: {
    text: "#11181C",
    textSecondary: "#687076",
    background: "#fff",
    tint: tintColorLight,
    icon: "#687076",
    tabIconDefault: "#687076",
    tabIconSelected: tintColorLight,
  },
  dark: {
    text: "#ECEDEE",
    textSecondary: "#9BA1A6",
    background: "#151718",
    tint: tintColorDark,
    icon: "#9BA1A6",
    tabIconDefault: "#9BA1A6",
    tabIconSelected: tintColorDark,
  },
};
